// Forms
(function($){

// if an invalid form field has been made valid,
// remove the shouty error highlighting - if a valid
// required field has been made invalid, start shouting

	$(document).on('gform_post_render', function(){
		$('input, textarea, select').on('change', function(){
		    var $input     = $(this);
		    var isRequired = $input.parents('.gfield').is('.gfield_contains_required');
		    var isValid    = $input.is(':valid');

		    if ( isRequired && isValid ) {
		        $input.parents('.gfield').removeClass('gfield_error');
		        $input.parent().next('.validation_message').slideUp();
		    }

		}).blur(function(){
		    var $input     = $(this);
		    var isRequired = $input.parents('.gfield').is('.gfield_contains_required');
		    var isInValid  = $input.is(':invalid');
		    var isEmpty    = $input.val() === '';

		    if ( isRequired && ( isInValid || isEmpty ) ) {
		        $input.parents('.gfield').addClass('gfield_error');
		        $input.parent().next('.validation_message').slideDown();
		    }
		});
	});

})(jQuery);
